export const PERSONA_CHARACTER_AVATAR_STALE_MS = 20 * 60 * 1000;

export type PersonaAvatarLifecycle = {
  avatarStatus?: string | null;
  avatarAttemptStartedAt?: Date | string | null;
  createdAt?: Date | string | null;
};

export function personaAvatarAttemptStartedMs(row: PersonaAvatarLifecycle): number {
  const value = row.avatarAttemptStartedAt ?? row.createdAt;
  if (!value) return 0;
  const millis = value instanceof Date ? value.getTime() : new Date(value).getTime();
  return Number.isFinite(millis) ? millis : 0;
}

export function personaAvatarAttemptIsStale(
  row: PersonaAvatarLifecycle,
  now = Date.now(),
  staleMs = PERSONA_CHARACTER_AVATAR_STALE_MS,
): boolean {
  const started = personaAvatarAttemptStartedMs(row);
  return !started || now - started > staleMs;
}

export function personaAvatarIsStalled(
  row: PersonaAvatarLifecycle,
  now = Date.now(),
  staleMs = PERSONA_CHARACTER_AVATAR_STALE_MS,
): boolean {
  return (row.avatarStatus === "pending" || row.avatarStatus === "generating")
    && personaAvatarAttemptIsStale(row, now, staleMs);
}